import { render, staticRenderFns } from "./CreateServiceRequest.vue?vue&type=template&id=5f4c8b91"
import script from "./CreateServiceRequest.vue?vue&type=script&lang=js"
export * from "./CreateServiceRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports